import { render } from "./PrettyCheckbox.vue?vue&type=template&id=00395be0&scoped=true"
import script from "./PrettyCheckbox.vue?vue&type=script&lang=js"
export * from "./PrettyCheckbox.vue?vue&type=script&lang=js"

import "./PrettyCheckbox.vue?vue&type=style&index=0&id=00395be0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dalmatian2.reunionmarketing.com/dalmatian2.reunionmarketing.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00395be0"]])

export default __exports__